<template>
  <div class="reservationCard">
    <reservation-form />
  </div>
</template>

<script>
import ReservationForm from "@/components/records/reservation/ReservationForm"

export default {
  name: "RecordsResa",
  components: {
    ReservationForm
  }
}
</script>

<style scoped lang="scss">
$c: ".reservationCard";

#{$c} {
}
</style>